<template>
    <div>
        <div  id="panel-description" class="panel">
            <div class="panel-hdr bg-primary-700 bg-success-gradient">
                <h2 v-if="is_new">
                    Новий тендер
                </h2>
                
                <h2 v-else>
                    Редагувати тендер № {{ this.tender_id }}
                </h2>
                
                <div class="panel-toolbar">
                    
                    <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse">
                    </button>
                    
                    <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>
            
            <div class="panel-container collapse show">
                <div class="panel-content">
                    <BOverlay :show="is_load">
                        <BTabs  v-model:index="tabIndex" v-model="tabId" content-class="mt-3">
                            
                            <BTab v-for="(tab,index) in tabs"
                                  :disabled="tab.disabled"
                                  :id="index"
                                  :title="tab.title"
                                  :active="tab.is_active"
                                  :key="index"
                            >
                                
                                <template #title>
                                    {{tabTitle(tab)}}
                                    <BSpinner type="grow" small v-if="tab.is_load" />
                                </template>
                                
                                <component
                                    @changeAtr="changeTenderAtr"
                                    v-bind:is="tab.index"
                                    :tender="tender">
                                </component>
                            </BTab>
                        </BTabs>
                        
                        <!-- Control buttons-->
                        <div class="text-center">
                            <BButtonGroup class="mt-2">
                                <BButton variant="outline-primary" @click="tabIndex--">Назад</BButton>
                                <b-button variant="outline-primary" @click="tabIndex++">Далі</b-button>
                            </BButtonGroup>
                        </div>
                        
                        <div class="pt-3">
                            <BButton class="waves-effect waves-themed"
                                     variant="outline-primary" @click="save">Зберегти</BButton>
                            
                            <BButton v-if="!is_published"
                                     variant="primary" class="waves-effect waves-themed ml-3" @click="publish">Опублікувати
                            </BButton>
                            
                            <BButton v-else class="waves-effect waves-themed ml-3" variant="danger" @click="archive">
                                Зняти з публікації
                            </BButton>
                            
                            <BButton v-if="is_published" class="btn btn-ok waves-effect waves-themed ml-3" @click="show_letter_form">e-mail</BButton>
                        </div>
                        
                        <tender_letter @send="onSendLetter"  :tender_id="parseInt(this.tender.id)"></tender_letter>
                    </BOverlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BButtonGroup
} from 'bootstrap-vue-next';


import tender_general from "./tabs/tender_general.vue";
import tender_description from "./tabs/tender_description.vue";
import tender_nomenclature from "./tabs/tender_nomenclature.vue";
import tender_files from "./tabs/tender_files.vue";
import tender_users from "./tabs/tender_users.vue";
import tender_invitations from "./tabs/tender_invitations.vue";
import Tender_letter from "./letter/tender_letter.vue";
import tender_users_in from "./tabs/tender_users_in.vue";

export default {
    name: "tender",
    
    components : {
        Tender_letter,
        BTab,
        BTabs,
        BOverlay,
        BSpinner,
        BButton,
        BButtonGroup,
        //Tabs
        tender_general,
        tender_description,
        tender_nomenclature,
        tender_files,
        tender_users,
        tender_invitations,
        tender_users_in
    },
    
    props: {
        tender_id: {
            type: [Number, String],
            default : 0,
        }
    },
    
    data() {
        return {
            is_load: false,
            tabIndex : -1,
            tabId : "tender_general",
            tender : {
            
            },
            tabs : []
        }
    },
    
    
    created() {
        this.tender.id = this.tender_id;
        this.loadTender();
    },
    
    methods : {
        
        async onSendLetter(body,users) {
            IMC_CORE.showloading();
            await this.save_req().then(({data}) => {
                api.patch('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/email/notification",{
                    'body' : body,
                    'users' : users,
                }).then(({data}) => {
                    IMC_CORE.hideloading();
                    IMC_CORE.snackbar('Відправлено Емейл');
                    this.loadTender();
                })
            }).catch(response => {
                IMC_CORE.hideloading();
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },
        
        tabTitle(tab) {
            if(tab.index === 'tender_nomenclature') {
                return `Номенклатура (${this.tender.positions?.length || 0})`;
            }
            
            if(tab.index === 'tender_files') {
                return `Файли (${this.tender.files?.length || 0})`;
            }
            
            if(tab.index === 'tender_users') {
                return `Підписано (${this.tender.subscribes?.length || 0})`;
            }
            
            if(tab.index === 'tender_invitations') {
                return `Запрошено (${this.tender.invitations?.length || 0})`;
            }
            
            if(tab.index === 'tender_users_in') {
                if(this.is_first) {
                    return 'Тендер доступний усім користувачам';
                }
                
                return `Тендер доступний (${this.tender.subscribes_in?.length || 0}) учасникам`;
            }
            
            return tab.title;
        },
        
        async save() {
            IMC_CORE.showloading();
            await this.save_req().then(({data}) => {
                IMC_CORE.hideloading();
                IMC_CORE.snackbar('Збережено');
                
                if(parseInt(this.tender.id) === 0) {
                    window.location.href = '/tender/edit/' + data.data.id;
                }
                
                this.tender.id = data.data.id;
                this.loadTender();
                
            }).catch((error) => {
                IMC_CORE.hideloading();
                const data = error?.response?.data;
                EventBus.$emit('show_toast', {
                    title: data?.status || 'Error',
                    err: data?.message || (Array.isArray(data?.data?.errors) ? data.data.errors.join('\n') : 'Unknown error'),
                    type: 'danger',
                });
            })
        },
        
        async publish() {
            
            IMC_CORE.showloading();
            await this.save_req().then(({data}) => {
                
                 this.tender.id = data.data.id;
                 api.patch('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/publish").then(({data}) => {
                    IMC_CORE.hideloading();
                    IMC_CORE.snackbar('Опубліковано');
                    this.loadTender();
                })
            }).catch((error) => {
                IMC_CORE.hideloading();
                const data = error?.response?.data;
                EventBus.$emit('show_toast', {
                    title: data?.status || 'Error',
                    err: data?.message || (Array.isArray(data?.data?.errors) ? data.data.errors.join('\n') : 'Unknown error'),
                    type: 'danger',
                });
            })
        },
        
        archive() {
            IMC_CORE.showloading();
            api.patch('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/archive").then(({data}) => {
                IMC_CORE.hideloading();
                IMC_CORE.snackbar('Знято з публікації')
                
                this.loadTender();
            }).catch((error) => {
                IMC_CORE.hideloading();
                const data = error?.response?.data;
                EventBus.$emit('show_toast', {
                    title: data?.status || 'Error',
                    err: data?.message || (Array.isArray(data?.data?.errors) ? data.data.errors.join('\n') : 'Unknown error'),
                    type: 'danger',
                });
            })
        },
        
        async save_req() {
            return api.put('/tenders/sales/tenders/' + parseInt(this.tender.id),
                this.tender
            );
        },
        
        changeTenderAtr(atrName,atrVal) {
        
        },
        
        show_letter_form() {
            EventBus.$emit('show_email_tender');
        },
        
        async loadTender() {
            this.is_load = true;
            
            let url = '/tenders/sales/tenders/' + parseInt(this.tender.id);
            if(parseInt(this.tender_id) > 0) {
                url = url + "/edit";
            }
            
            await api.get(url).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.tender = data.data;
                    this.pushPayment();
                    this.pushTabs();
                    
                    EventBus.$emit('reload_tender');
                }
            }).catch((error) => {
                IMC_CORE.hideloading();
                const data = error?.response?.data;
                EventBus.$emit('show_toast', {
                    title: data?.status || 'Error',
                    err: data?.message || (Array.isArray(data?.data?.errors) ? data.data.errors.join('\n') : 'Unknown error'),
                    type: 'danger',
                });
            })
        },
        
        pushPayment() {
            if(!this.tender.hasOwnProperty('payment')) {
                this.tender.payment = {
                    prepay: 100,
                    postday: 0,
                    postpay_description: '',
                    prepay_description: '',
                    postperiod: 0
                };
            }
            
            if(!this.tender.hasOwnProperty('invitations')) {
                this.tender.invitations = [];
            }
            
            if(!this.tender.hasOwnProperty('positions')) {
                this.tender.positions = [];
            }
            
            if(!this.tender.hasOwnProperty('files')) {
                this.tender.files = [];
            }
            
            if(!this.tender.hasOwnProperty('id')) {
                this.tender.id = 0;
            }
            
            if(!this.tender.hasOwnProperty('subscribes_in')) {
                this.tender.subscribes_in = [];
            }
            
            if(!this.tender.hasOwnProperty('subscribes')) {
                this.tender.subscribes = [];
            }
            
        },
        
        pushTabs() {
            this.tabs = [];
            
            this.default_tabs.map(item => {
                this.tabs.push({
                    title       : item.title,
                    disabled    : item.disabled,
                    is_active   : item.is_active,
                    is_load     : false,
                    index       : item.index,
                });
            });
        },
        
    },
    
    computed : {
        
        is_new() {
            return parseInt(this.tender_id) === 0;
        },
        
        is_published () {
            let cur_state = this.tender?.status;
            return cur_state === 'published';
        },
        
        
        is_first() {
            return this.tender.type === 'first_simple';
        },
        
        default_tabs() {
            
            let def =  [
                {
                    "title": "Реквізити",
                    "index": "tender_general",
                    is_active: true,
                    disabled : false,
                },
                {
                    "title": "Опис",
                    "index": "tender_description",
                    is_active: false,
                    disabled : false,
                },
                {
                    "title": "Номенклатура ",
                    "index": "tender_nomenclature",
                    is_active: false,
                    disabled : false,
                }
            ];
            const  tender_type =this.tender.tender_type;
            let is_simple = tender_type === 'first_simple';
            
            if(is_simple) {
                def.push({
                    "title": "Файли",
                    "index": "tender_files",
                    is_active: false,
                    disabled : false,
                });
                
                def.push({
                    "title": "Підписано",
                    "index": "tender_users",
                    is_active: false,
                    disabled : false,
                });
                
                def.push({
                    "title": "Запрошено",
                    "index": "tender_invitations",
                    is_active: false,
                    disabled : false,
                });
              
            }
          
            
            if(tender_type == 'second_simple') {
                def.push({
                    "title": "Файли",
                    "index": "tender_files",
                    is_active: false,
                    disabled : false,
                });
                
            }
            
            def.push({
                "title": "Тендер доступний усім користувачам",
                "index": "tender_users_in",
                is_active: false,
                disabled : this.is_first,
            });
          
            
            
            return def;
        },
    }
    
}
</script>


<style scoped>

</style>